import { SelectInput, FileInput, FileField, required } from 'react-admin';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import { TextField } from '@mui/material';
import { DefaultToolbarStyled } from '@/styles/overrides';
import { path } from './constants';
import { Container, FileUrlContainer } from './styled';
import { RequestOneOffCheckProps } from '../types';
import useController from './useController';

const FormContent = (props: RequestOneOffCheckProps) => {
  const { checkName, choices, disabled, fileInputOptions, fileUrl, handleRequest, isUpdating, validateProof } =
    useController(props);

  return (
    <>
      <Container>
        {isUpdating && <TextField disabled label="Check Type" value={checkName} />}
        <SelectInput
          choices={choices}
          label={isUpdating ? 'Status' : 'Check Type'}
          source={path('action')}
          validate={required()}
        />
        {isUpdating && (
          <>
            <FileInput
              accept={{ 'application/pdf': ['.pdf'] }}
              defaultValue={null}
              label="Attach Proof"
              options={fileInputOptions}
              source={path('file')}
              validate={validateProof}
            >
              <FileField source="src" title="title" />
            </FileInput>

            {fileUrl && (
              <FileUrlContainer>
                <CloudDoneIcon />
                <span>{fileUrl}</span>
              </FileUrlContainer>
            )}
          </>
        )}
      </Container>

      <DefaultToolbarStyled
        onClose={props.onClose}
        onSave={handleRequest}
        saveButtonLabel={isUpdating ? 'Save' : 'Request'}
        disabled={disabled}
      />
    </>
  );
};

export default FormContent;
